"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.H4 = exports.H3 = exports.H2 = exports.H1 = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _variables = require("../../styles/variables");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var stylesXL = "\n    font-size: 40px;\n    line-height: 48px;\n    letter-spacing: -1.5px;\n\n    @media (min-width: ".concat(_variables.breakpoints.medium, ") {\n        font-size: 60px;\n        line-height: 72px;\n    }\n    \n    @media (min-width: ").concat(_variables.breakpoints.large, ") {\n        font-size: 72px;\n        line-height: 86px;\n        letter-spacing: -2px;\n    }\n");
var stylesL = "\n    font-size: 32px;\n    line-height: 40px;\n    letter-spacing: -1.5px;\n\n    @media (min-width: ".concat(_variables.breakpoints.medium, ") {\n        font-size: 48px;\n        line-height: 58px;\n    }\n    \n    @media (min-width: ").concat(_variables.breakpoints.large, ") {\n        font-size: 60px;\n        line-height: 72px;\n        letter-spacing: -2px;\n    }\n");
var stylesM = "\n    font-size: 24px;\n    line-height: 32px;\n    letter-spacing: -1px;\n\n    @media (min-width: ".concat(_variables.breakpoints.medium, ") {\n        font-size: 32px;\n        line-height: 40px;\n    }\n    \n    @media (min-width: ").concat(_variables.breakpoints.large, ") {\n        font-size: 36px;\n        line-height: 44px;\n        letter-spacing: -1.5px;\n    }\n");
var stylesS = "\n    font-size: 20px;\n    line-height: 28px;\n    letter-spacing: -.5px;\n\n    @media (min-width: ".concat(_variables.breakpoints.medium, ") {\n        font-size: 24px;\n        line-height: 32px;\n        letter-spacing: -1px;\n    }\n");
var typographyStyles = function typographyStyles(_ref) {
  var darkmode = _ref.darkmode,
    textAlign = _ref.textAlign,
    customColor = _ref.customColor,
    styleVariant = _ref.styleVariant;
  var currentStyles = function currentStyles() {
    switch (styleVariant) {
      case 'XL':
        return stylesXL;
      case 'L':
        return stylesL;
      case 'M':
        return stylesM;
      case 'S':
      default:
        return stylesS;
    }
  };
  return "\n        font-family: 'Gilroy', sans-serif;\n        font-weight: 800;\n        position: relative;\n\n        color: ".concat(customColor || darkmode ? _variables.colors.white : _variables.colors.blackHighContrast, ";\n\n        text-align: ").concat(textAlign, ";\n\n        ").concat(currentStyles(), "\n    ");
};
var H1 = _styledComponents["default"].h1.withConfig({
  componentId: "appname-__sc-14u0am3-0"
})(["", ""], function (_ref2) {
  var headingConfig = _ref2.headingConfig;
  return typographyStyles(headingConfig);
});
exports.H1 = H1;
var H2 = _styledComponents["default"].h2.withConfig({
  componentId: "appname-__sc-14u0am3-1"
})(["", ""], function (_ref3) {
  var headingConfig = _ref3.headingConfig;
  return typographyStyles(headingConfig);
});
exports.H2 = H2;
var H3 = _styledComponents["default"].h3.withConfig({
  componentId: "appname-__sc-14u0am3-2"
})(["", ""], function (_ref4) {
  var headingConfig = _ref4.headingConfig;
  return typographyStyles(headingConfig);
});
exports.H3 = H3;
var H4 = _styledComponents["default"].h4.withConfig({
  componentId: "appname-__sc-14u0am3-3"
})(["", ""], function (_ref5) {
  var headingConfig = _ref5.headingConfig;
  return typographyStyles(headingConfig);
});
exports.H4 = H4;